import apiRequest from '../apis/api-request';
import { selectAuthToken } from '../redux/reducers/authReducers';
import { store } from '../redux/store';

const lunchService = {

    getLunchSessionByUserId: async (id) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "GET",
            url: `/api/lunch?user_id=${id}`,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    createLunchSession: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/lunch`,
            data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

    todayLunchUsers: async (data) => {
        const token = selectAuthToken(store.getState());
        return apiRequest({
            method: "POST",
            url: `/api/lunch/today`,
            data,
            headers: {
                Authorization: "Bearer " + token
            },
        });
    },

};

export default lunchService;